import { Card, CardContent } from "../../components/ui/card";
import { 
  Eye, 
  Shield, 
  Users, 
  Zap, 
  Heart, 
  Building2 
} from "lucide-react";
import { 
  MapPin,        // for Geo tagging
  ShieldCheck,   // for blockchain security
  AlertTriangle, // for duplicate detection
  Globe,         // for public portal
  FileText       // for documents
} from "lucide-react";

export default function Features() {


const features = [
  {
    icon: MapPin,
    title: "Geo-Tagged Records",
    description:
      "Every infrastructure project is mapped with precise latitude and longitude coordinates, ensuring accurate location tracking and better planning through GIS integration.",
    color: "text-blue-600",
    bgColor: "bg-blue-50",
    borderColor: "border-blue-200",
  },
  {
    icon: ShieldCheck,
    title: "Immutable Blockchain Storage",
    description:
      "All approved records are securely stored on blockchain technology, making them tamper-proof, transparent, and permanently unalterable.",
    color: "text-green-600",
    bgColor: "bg-green-50",
    borderColor: "border-green-200",
  },
  {
    icon: Users,
    title: "Multi-Level Approval System",
    description:
      "Projects go through multiple levels of verification and approvals from authorities, ensuring authenticity, accountability, and data reliability.",
    color: "text-purple-600",
    bgColor: "bg-purple-50",
    borderColor: "border-purple-200",
  },
  {
    icon: AlertTriangle,
    title: "Duplicate Work Detection",
    description:
      "Smart system automatically detects and alerts if similar infrastructure work already exists at the same location, preventing redundancy and saving resources.",
    color: "text-yellow-600",
    bgColor: "bg-yellow-50",
    borderColor: "border-yellow-200",
  },
  {
    icon: Globe,
    title: "Public Transparency Portal",
    description:
      "Citizens can view all ongoing and completed infrastructure projects, promoting transparency, trust, and public participation in governance.",
    color: "text-red-600",
    bgColor: "bg-red-50",
    borderColor: "border-red-200",
  },
  {
    icon: FileText,
    title: "Document Management System",
    description:
      "Upload and manage all related documents such as work orders, tenders, approvals, and completion reports in a centralized and organized manner.",
    color: "text-primary",
    bgColor: "bg-blue-50",
    borderColor: "border-primary/20",
  },
];
const featuresold1 = [
  {
    icon: Eye,
    title: "Geo-Tagged Records",
    description:
      "Every infrastructure project is mapped with precise latitude and longitude coordinates, ensuring accurate location tracking and better planning through GIS integration.",
    color: "text-blue-600",
    bgColor: "bg-blue-50",
    borderColor: "border-blue-200",
  },
  {
    icon: Shield,
    title: "Immutable Blockchain Storage",
    description:
      "All approved records are securely stored on blockchain technology, making them tamper-proof, transparent, and permanently unalterable.",
    color: "text-green-600",
    bgColor: "bg-green-50",
    borderColor: "border-green-200",
  },
  {
    icon: Users,
    title: "Multi-Level Approval System",
    description:
      "Projects go through multiple levels of verification and approvals from authorities, ensuring authenticity, accountability, and data reliability.",
    color: "text-purple-600",
    bgColor: "bg-purple-50",
    borderColor: "border-purple-200",
  },
  {
    icon: Zap,
    title: "Duplicate Work Detection",
    description:
      "Smart system automatically detects and alerts if similar infrastructure work already exists at the same location, preventing redundancy and saving resources.",
    color: "text-yellow-600",
    bgColor: "bg-yellow-50",
    borderColor: "border-yellow-200",
  },
  {
    icon: Heart,
    title: "Public Transparency Portal",
    description:
      "Citizens can view all ongoing and completed infrastructure projects, promoting transparency, trust, and public participation in governance.",
    color: "text-red-600",
    bgColor: "bg-red-50",
    borderColor: "border-red-200",
  },
  {
    icon: Building2,
    title: "Document Management System",
    description:
      "Upload and manage all related documents such as work orders, tenders, approvals, and completion reports in a centralized and organized manner.",
    color: "text-primary",
    bgColor: "bg-blue-50",
    borderColor: "border-primary/20",
  },
];

  const featuresold = [
    {
      icon: Eye,
      title: "Geo-Tagged Records",
      description: "Every transaction recorded immutably on the blockchain, providing complete visibility into TDR document history and ownership changes.",
      color: "text-blue-600",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-200"
    },
    {
      icon: Shield,
      title: "Security",
      description: "Cryptographic protection against tampering, fraud, and unauthorized modifications ensures the integrity of all TDR documents.",
      color: "text-green-600", 
      bgColor: "bg-green-50",
      borderColor: "border-green-200"
    },
    {
      icon: Users,
      title: "Accountability",
      description: "All stakeholders including developers, citizens, and authorities can verify TDR documents and track their complete transaction history.",
      color: "text-purple-600",
      bgColor: "bg-purple-50", 
      borderColor: "border-purple-200"
    },
    {
      icon: Zap,
      title: "Efficiency",
      description: "Faster document validation and transfer processes eliminate bureaucratic delays and streamline TDR transactions across the region.",
      color: "text-yellow-600",
      bgColor: "bg-yellow-50",
      borderColor: "border-yellow-200"
    },
    {
      icon: Heart,
      title: "Trust",
      description: "Reduces fraud and eliminates middlemen by providing a direct, verifiable connection between document issuers and recipients.",
      color: "text-red-600",
      bgColor: "bg-red-50",
      borderColor: "border-red-200"
    },
    {
      icon: Building2,
      title: "Government-Backed",
      description: "Managed by PMRDA with full regulatory oversight, ensuring compliance with all government standards and legal requirements.",
      color: "text-primary",
      bgColor: "bg-blue-50",
      borderColor: "border-primary/20"
    }
  ];

  return (
    <section id="features" className="py-20 bg-background">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
           Key Features of Blockchain
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              Our blockchain-powered Auction platform ensures transparency, security, and trust in all government auctions, making bidding fair and tamper-proof.
         
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <Card 
                key={index} 
                className={`group hover:shadow-lg transition-all duration-300 hover:-translate-y-1 ${feature.borderColor} ${feature.bgColor}/30`}
              >
                <CardContent className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className={`w-12 h-12 ${feature.bgColor} rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                      <IconComponent className={`w-6 h-6 ${feature.color}`} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-xl font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                        ✅ {feature.title}
                      </h3>
                      <p className="text-muted-foreground leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Benefits */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-primary/10 via-accent/10 to-primary/10 rounded-2xl p-8">
            <h3 className="text-2xl font-semibold text-foreground mb-4">
              Benefits for All Stakeholders
            </h3>
            <div className="grid md:grid-cols-3 gap-8 mt-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-primary rounded-full mx-auto mb-4 flex items-center justify-center">
                  <Building2 className="w-8 h-8 text-white" />
                </div>
                <h4 className="font-semibold text-foreground mb-2">For Government</h4>
                <p className="text-sm text-muted-foreground">
                  Enhanced oversight, reduced administrative burden, and improved citizen trust
                </p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-accent rounded-full mx-auto mb-4 flex items-center justify-center">
                  <Users className="w-8 h-8 text-white" />
                </div>
                <h4 className="font-semibold text-foreground mb-2">For Developers</h4>
                <p className="text-sm text-muted-foreground">
                  Faster approvals, transparent processes, and reduced compliance risks
                </p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-green-600 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <Heart className="w-8 h-8 text-white" />
                </div>
                <h4 className="font-semibold text-foreground mb-2">For Citizens</h4>
                <p className="text-sm text-muted-foreground">
                  Complete transparency, fraud protection, and easy verification access
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}